var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('questions-sub-page-base',{attrs:{"resolution-id":_vm.resolutionId,"resolution-type":_vm.RESOLUTION_TYPES.GENERAL_MEETING,"is-preview":_vm.isPreview,"building-id":_vm.buildingId}})}
var staticRenderFns = []

export { render, staticRenderFns }